import React from 'react';
import PropTypes from 'prop-types';

export const Edit = ({ width, height, ...props }) => (
  <svg
    width={ width }
    height={ height }
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    { ...props }
  >
    <path
      d='M3 21V16.75L16.2 3.575C16.4 3.39167 16.6208 3.25 16.8625 3.15C17.1042 3.05 17.3583 3 17.625 3C17.8917 3 18.15 3.05 18.4 3.15C18.65 3.25 18.8667 3.4 19.05 3.6L20.425 5C20.625 5.18333 20.7708 5.4 20.8625 5.65C20.9542 5.9 21 6.15 21 6.4C21 6.66667 20.9542 6.92083 20.8625 7.1625C20.7708 7.40417 20.625 7.625 20.425 7.825L7.25 21H3ZM17.6 7.8L19 6.4L17.6 5L16.2 6.4L17.6 7.8Z'
      fill='currentColor'
    />
  </svg>
);

Edit.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Edit.defaultProps = {
  width: 24,
  height: 24,
};
